export default {"src":"/_next/static/media/proactive-remediation.f0e8a17c.svg","height":230,"width":229,"blurWidth":0,"blurHeight":0};